import React from 'react';
import StarIcon from '../star';

export interface RatingStatProps {
  ratingValue: number;
  ratingText?: string;
  ratingCount: number;
  totalRatings: number;
  className?: string;
}

const RatingStat: React.FC<RatingStatProps> = ({
  ratingValue,
  ratingText = 'star',
  ratingCount,
  totalRatings,
  className = '',
}) => {
  const percent = totalRatings ? Math.round((ratingCount / totalRatings) * 100) : 0;
  const barWidth = `${percent}%`;
  return (
    <div
      className={`flex items-center gap-4 ${className}`}
      aria-label={`${ratingValue} ${ratingText}${ratingValue > 1 ? 's' : ''}, ${percent}% (${ratingCount})`}
    >
      <div className="flex min-w-fit items-center justify-end gap-2">
        <p className="body-text-small min-w-40 font-medium text-text-primary">
          {ratingValue} {ratingText}
        </p>
        <StarIcon variant="filled" size={24} />
      </div>
      <div className="h-12 bg-icon-tertiary" style={{ width: barWidth }} />
      <p className="body-text-small min-w-fit font-medium text-text-tertiary">
        {percent}% ({ratingCount})
      </p>
    </div>
  );
};

export default RatingStat;
